import { translateGameText } from './gameTextI18n';

const DEFAULT_EFSUN_TYPES = {
  attack_power: { label: 'Saldırı Gücü' },
  fire_resistance: { label: 'Ateş Direnci', percent: true, damageType: 'fire' },
  water_resistance: { label: 'Su Direnci', percent: true, damageType: 'water' },
  electric_resistance: { label: 'Toprak Direnci', percent: true, damageType: 'earth' },
  earth_resistance: { label: 'Toprak Direnci', percent: true, damageType: 'earth' },
  magic_resistance: { label: 'Büyü Direnci', percent: true, damageType: 'magic' },
  max_hp: { label: 'Max HP' },
  max_sp: { label: 'Max SP' },
  spell_speed: { label: 'Büyü Hızı', percent: true },
  hp_absorb_damage: { label: 'HP Emme', percent: true },
  sp_absorb_damage: { label: 'SP Emme', percent: true },
  melee_reflect_chance: { label: 'Yakın Dövüş Yansıtma', percent: true },
  normal_damage_percent: { label: 'Zarar Artışı', percent: true, signed: true },
  skill_damage_percent: { label: 'Beceri Artışı', percent: true, signed: true },
  fire_strong: { label: 'Ateşe Karşı Güçlü', percent: true, damageType: 'fire' },
  water_strong: { label: 'Suya Karşı Güçlü', percent: true, damageType: 'water' },
  earth_strong: { label: 'Toprağa Karşı Güçlü', percent: true, damageType: 'earth' },
  magic_strong: { label: 'Büyüye Karşı Güçlü', percent: true, damageType: 'magic' },
  monster_strong: { label: 'Canavarlara Karşı Güçlü', percent: true },
  strength: { label: 'Güç' },
  intelligence: { label: 'Zeka' },
  agility: { label: 'Çeviklik' },
  vitality: { label: 'Canlılık' },
  critical_chance: { label: 'Kritik Vuruş Şansı', percent: true },
  pierce_chance: { label: 'Delici Vuruş Şansı', percent: true },
  attack_speed: { label: 'Saldırı Hızı', percent: true },
  hp_production: { label: 'HP-Üretimi', percent: true },
  sp_production: { label: 'SP-Üretimi', percent: true },
  exp_bonus_chance: { label: 'EXP Bonus Şansı', percent: true },
  double_yang_drop_chance: { label: 'İki Kat Yang Düşürme Şansı', percent: true },
  double_item_drop_chance: { label: 'İki Kat Eşya Düşürme Şansı', percent: true },
  sp_steal_chance: { label: 'SP Çalma Şansı', percent: true },
  hp_steal_chance: { label: 'Can Çalma', percent: true },
  damage_reduction: { label: 'Vuruş Azaltma', percent: true },
  damage_reflect: { label: 'Vuruş Yansıtma', percent: true },
  human_strong: { label: 'İnsanlara Karşı Güçlü', percent: true },
  warrior_strong: { label: "Alp'e Karşı Güçlü", percent: true },
  sura_strong: { label: "Kara Alp'e Karşı Güçlü", percent: true },
  human_resistance: { label: 'İnsan Savunması', percent: true },
  warrior_resistance: { label: 'Alp Savunması', percent: true },
  sura_resistance: { label: 'Kara Alp Savunması', percent: true },
  critical_resistance: { label: 'Kritik Vuruşa Dayanıklılık', percent: true },
  pierce_resistance: { label: 'Delici Vuruşa Dayanıklılık', percent: true },
  metin_strong: { label: 'Göktaşlarına Karşı Güçlü', percent: true },
  boss_strong: { label: 'Patronlara Karşı Güçlü', percent: true },
  avg_damage_resistance: { label: 'Ortalama Zarar Direnci', percent: true },
  skill_damage_resistance: { label: 'Beceri Hasarı Direnci', percent: true },
  block_chance: { label: 'Bloklama Şansı', percent: true },
  dodge_chance: { label: 'Kaçınma Şansı', percent: true }
};

const DEFAULT_EFSUN_PROFILES = {
  armor: {
    tierWeights: [30, 25, 22, 15, 8],
    types: {
      attack_power: [5, 10, 15, 30, 50],
      fire_resistance: [2, 4, 6, 10, 15],
      water_resistance: [2, 4, 6, 10, 15],
      earth_resistance: [2, 4, 6, 10, 15],
      magic_resistance: [2, 4, 6, 10, 15],
      max_hp: [500, 1000, 1500, 2000, 2500],
      max_sp: [10, 25, 50, 80, 100],
      spell_speed: [4, 6, 10, 20, 25],
      hp_absorb_damage: [2, 4, 6, 8, 10],
      sp_absorb_damage: [2, 4, 6, 8, 10],
      melee_reflect_chance: [2, 4, 6, 8, 10]
    }
  },
  weapon: {
    tierWeights: [30, 25, 22, 15, 8],
    types: {
      fire_strong: [4, 6, 10, 15, 20],
      water_strong: [4, 6, 10, 15, 20],
      magic_strong: [4, 6, 10, 15, 20],
      earth_strong: [4, 6, 10, 15, 20],
      monster_strong: [4, 6, 10, 15, 20],
      strength: [2, 4, 6, 8, 12],
      intelligence: [2, 4, 6, 8, 12],
      agility: [2, 4, 6, 8, 12],
      vitality: [2, 4, 6, 8, 12],
      spell_speed: [4, 6, 10, 15, 20],
      critical_chance: [2, 4, 6, 8, 10],
      pierce_chance: [2, 4, 6, 8, 10]
    }
  },
  helmet: {
    tierWeights: [30, 25, 22, 15, 8],
    types: {
      fire_strong: [4, 6, 10, 15, 20],
      water_strong: [4, 6, 10, 15, 20],
      magic_strong: [4, 6, 10, 15, 20],
      earth_strong: [4, 6, 10, 15, 20],
      monster_strong: [4, 6, 10, 15, 20],
      fire_resistance: [2, 4, 6, 10, 15],
      water_resistance: [2, 4, 6, 10, 15],
      earth_resistance: [2, 4, 6, 10, 15],
      magic_resistance: [2, 4, 6, 10, 15],
      attack_speed: [1, 2, 3, 5, 8],
      hp_production: [4, 8, 12, 20, 30],
      sp_production: [4, 8, 12, 20, 30],
      sp_absorb_damage: [2, 4, 6, 8, 10]
    }
  },
  boot: {
    tierWeights: [30, 25, 22, 15, 8],
    types: {
      max_hp: [500, 1000, 1500, 2000, 2500],
      max_sp: [10, 25, 50, 80, 100],
      critical_chance: [2, 4, 6, 8, 10],
      pierce_chance: [2, 4, 6, 8, 10],
      attack_speed: [1, 2, 3, 5, 8],
      exp_bonus_chance: [2, 4, 6, 8, 20],
      double_yang_drop_chance: [2, 4, 6, 8, 20],
      hp_absorb_damage: [2, 4, 6, 8, 10],
      sp_absorb_damage: [2, 4, 6, 8, 10]
    }
  },
  shield: {
    tierWeights: [30, 25, 22, 15, 8],
    types: {
      fire_strong: [4, 6, 10, 15, 20],
      water_strong: [4, 6, 10, 15, 20],
      magic_strong: [4, 6, 10, 15, 20],
      earth_strong: [4, 6, 10, 15, 20],
      monster_strong: [4, 6, 10, 15, 20],
      damage_reduction: [4, 6, 10, 15, 20],
      damage_reflect: [4, 6, 10, 15, 20],
      exp_bonus_chance: [2, 4, 6, 8, 20],
      double_yang_drop_chance: [2, 4, 6, 8, 20],
      strength: [2, 4, 8, 10, 12],
      intelligence: [2, 4, 8, 10, 12],
      agility: [2, 4, 8, 10, 12],
      vitality: [2, 4, 8, 10, 12]
    }
  },
  necklace: {
    tierWeights: [30, 25, 22, 15, 8],
    types: {
      exp_bonus_chance: [2, 4, 6, 8, 20],
      double_yang_drop_chance: [2, 4, 6, 8, 20],
      critical_chance: [2, 4, 6, 8, 10],
      pierce_chance: [2, 4, 6, 8, 10],
      sp_steal_chance: [2, 4, 6, 8, 10],
      hp_steal_chance: [2, 4, 6, 8, 10],
      max_hp: [500, 1000, 1500, 2000, 2000],
      max_sp: [10, 25, 50, 80, 100],
      hp_production: [4, 8, 12, 20, 30],
      sp_production: [4, 8, 12, 20, 30]
    }
  },
  earring: {
    tierWeights: [30, 25, 22, 15, 8],
    types: {
      fire_strong: [4, 6, 10, 15, 20],
      water_strong: [4, 6, 10, 15, 20],
      magic_strong: [4, 6, 10, 15, 20],
      earth_strong: [4, 6, 10, 15, 20],
      monster_strong: [4, 6, 10, 15, 20],
      fire_resistance: [2, 4, 6, 10, 15],
      water_resistance: [2, 4, 6, 10, 15],
      earth_resistance: [2, 4, 6, 10, 15],
      magic_resistance: [2, 4, 6, 10, 15],
      double_item_drop_chance: [2, 4, 6, 8, 20],
      sp_steal_chance: [2, 4, 6, 8, 10],
      hp_steal_chance: [2, 4, 6, 8, 10],
      critical_chance: [2, 4, 6, 8, 10],
      pierce_chance: [2, 4, 6, 8, 10]
    }
  }
};

let efsunTypes = { ...DEFAULT_EFSUN_TYPES };
let efsunProfiles = { ...DEFAULT_EFSUN_PROFILES };

export const initEfsunConfig = (config) => {
  if (!config || typeof config !== 'object') return;
  if (config.types && typeof config.types === 'object') {
    efsunTypes = { ...DEFAULT_EFSUN_TYPES, ...config.types };
  }
  if (config.profiles && typeof config.profiles === 'object') {
    efsunProfiles = { ...DEFAULT_EFSUN_PROFILES, ...config.profiles };
  }
};

export const EFSUN_OPEN_TOOL_ID = 101;
export const EFSUN_REROLL_TOOL_ID = 102;
/** Efsun Küpü: 4 efsunlu eşyaya 5. efsunu açar. */
export const EFSUN_CUBE_TOOL_ID = 1505;
export const MAX_ARMOR_EFSUNS = 4;
export const MAX_WEAPON_EFSUNS = 4;
export const MAX_EQUIPMENT_EFSUNS = 4;

/** Olta / kazma — silah slotunda ama efsun alamaz (backend base_item_id ile aynı). */
export const FISHING_ROD_BASE_ITEM_ID = 13;
export const MINING_PICKAXE_BASE_ITEM_ID = 20;

export const resolveWeaponBaseItemId = (item) => {
  if (!item) return null;
  if (item.baseItemId != null && item.baseItemId !== 0) {
    return Number(item.baseItemId);
  }
  const catalogId = Number(item.baseItem?.id ?? item.weaponId ?? item.itemId);
  if (!Number.isFinite(catalogId) || catalogId <= 0) return null;
  // weapons.id = base*10 + enhancement (id >= 10)
  return catalogId >= 10 ? Math.floor(catalogId / 10) : catalogId;
};

export const isWeaponEfsunBlocked = (item) => {
  const baseId = resolveWeaponBaseItemId(item);
  return baseId === FISHING_ROD_BASE_ITEM_ID || baseId === MINING_PICKAXE_BASE_ITEM_ID;
};

export const EFSUN_INVENTORY_TYPE_TO_KIND = {
  armors: 'armor',
  weapons: 'weapon',
  helmets: 'helmet',
  boots: 'boot',
  shields: 'shield',
  necklaces: 'necklace',
  earrings: 'earring'
};

export const getEfsunKindForInventoryType = (inventoryType) =>
  EFSUN_INVENTORY_TYPE_TO_KIND[inventoryType] || null;

export const getEfsunKindForSlotType = (slotType) =>
  slotType || null;

export const formatEfsunCountLabel = (efsunlar, maxEfsuns = MAX_ARMOR_EFSUNS) => {
  const count = Array.isArray(efsunlar) ? efsunlar.length : 0;
  if (count === 0) return '';
  return `Efsunlar (${count}/${Math.max(maxEfsuns, count)})`;
};

export const getEfsunTypeLabel = (type) =>
  translateGameText('efsunTypeNames', type, efsunTypes[type]?.label || DEFAULT_EFSUN_TYPES[type]?.label || type);

const isPercentEfsunType = (type) => Boolean(efsunTypes[type]?.percent);

export const formatEfsunValue = (type, value) => {
  const numericValue = Number(value) || 0;
  const prefix = numericValue > 0 ? '+' : '';
  if (isPercentEfsunType(type)) {
    return `${prefix}${numericValue}%`;
  }
  return `${prefix}${numericValue}`;
};

export const formatEfsunRow = (efsun) => {
  if (!efsun?.type) return '';
  const label = getEfsunTypeLabel(efsun.type);
  const val = formatEfsunValue(efsun.type, efsun.value ?? 0);
  const tier = efsun.tier ? ` (T${efsun.tier})` : '';
  return `${label}: ${val}${tier}`;
};

const isSignedEfsunType = (type) => Boolean(efsunTypes[type]?.signed);

const getProfileTierValues = (type, profileName = 'armor') => {
  const profile = efsunProfiles[profileName];
  return profile?.types?.[type] || efsunProfiles.armor?.types?.[type];
};

export const inferEfsunTier = (type, value, tier, profileName = 'armor') => {
  const numericTier = Number(tier);
  if (numericTier >= 1 && numericTier <= 5) {
    return numericTier;
  }
  const tierValues = getProfileTierValues(type, profileName);
  if (!tierValues) return 1;
  const numericValue = Number(value) || 0;
  let bestTier = 1;
  tierValues.forEach((tierValue, index) => {
    if (numericValue >= tierValue) {
      bestTier = index + 1;
    }
  });
  return bestTier;
};

export const getEfsunValueColorClass = (type, value, tier, profileName = 'armor') => {
  const numericValue = Number(value) || 0;
  if (isSignedEfsunType(type)) {
    if (numericValue < 0) return 'efsun-value--negative';
    if (numericValue > 0) return 'efsun-value--positive';
    return '';
  }
  const resolvedTier = inferEfsunTier(type, numericValue, tier, profileName);
  return `efsun-value--tier-${resolvedTier}`;
};

export const getElementalResistancesFromEfsunlar = (efsunlar) => {
  const resist = { fire: 0, water: 0, earth: 0, magic: 0 };
  if (!Array.isArray(efsunlar)) return resist;
  efsunlar.forEach((e) => {
    const damageType = efsunTypes[e?.type]?.damageType;
    if (damageType) resist[damageType] += Number(e.value) || 0;
  });
  return resist;
};

export const DAMAGE_TYPE_LABELS = {
  fire: '🔥 Ateş',
  water: '💧 Su',
  earth: '🪨 Toprak',
  toprak: '🪨 Toprak', // legacy alias
  electric: '🪨 Toprak', // legacy alias
  magic: '✨ Büyü',
  none: 'Fiziksel'
};

export const formatDamageTypeLabel = (damageType) =>
  DAMAGE_TYPE_LABELS[damageType] || damageType || '';

export const formatResistanceSummary = (resist) => {
  if (!resist) return '';
  const parts = [];
  if (resist.fire > 0) parts.push(`Ateş %${resist.fire}`);
  if (resist.water > 0) parts.push(`Su %${resist.water}`);
  if (resist.earth > 0) parts.push(`Toprak %${resist.earth}`);
  if (resist.magic > 0) parts.push(`Büyü %${resist.magic}`);
  return parts.join(', ');
};
